import RunIf from './run-if';
import PollywogClassBrowseView from './browse-classes';
import SlideShowView from './slide-show';

export function init() {
	const bannerImagesElement = document.querySelector('.banner-images.dynamic');
	const browseViewElement   = document.querySelector('.pw-class-browse-view');

	// Create the banner images slideshow
	SlideShowView.create(bannerImagesElement);

	// Create the class browse view
	PollywogClassBrowseView.create(browseViewElement, true);
}

export function onLoad() {
	RunIf.isPage('page-template-home', init);
}



// WEBPACK FOOTER //
// ./assets/scripts/home.js